export default __webpack_public_path__ + "static/media/3031 spice rack B side.d6c6443d.png";